/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
import merge from 'lodash/merge'

// material UI
import createTheme from '@material-ui/core/styles/createTheme'
import { MuiThemeProvider } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
// import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
// import Button from '@material-ui/core/Button'
// import TextField from '@material-ui/core/TextField'

// material ui icon
import { ReactComponent as RcsLogo } from 'static/image/logo/rcs_logo.svg'

// my components
import withCompWidth from 'commonHoc/withCompWidth'
// import UserComponentName from 'components/molecules/UserComponentName'

// my containers
// import UserContainerName from 'containers/UserContainerName'
import CommonButton from 'containers/CommonButtonContainer'

// libraries
import config from 'config'
import nurigoTheme from 'themes/nurigo-material'
import { isArray } from 'lib/detectType'
// import isEqualProps from 'lib/isEqualProps'

export const useProps = {}
/**
 * (작성된 설명이 없습니다.)
 */
const styles = theme => ({
  root: {
    border: '1px solid #eee',
    borderRadius: 10,
    transition: 'border .2s, box-shadow .2s',
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: '0 0 10px 0px #00000017'
    }
  }
})
const RcsBrandItem = withStyles(styles)(props => {
  const { classes: cls, rcsBrand, onSelect } = props
  return (
    <Box
      p={2}
      className={cls.root}
      onClick={() => {
        onSelect(rcsBrand)
      }}
    >
      <Typography noWrap>
        <RcsLogo
          style={{
            marginRight: 4,
            width: '1.4em',
            height: '1.4em',
            verticalAlign: 'bottom'
          }}
        />
        <strong>{rcsBrand?.name}</strong>
      </Typography>
    </Box>
  )
})
const RcsBrandItems = props => {
  const { brandList, onSelect } = props
  if (!isArray(brandList)) return null
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={1} wrap="nowrap" alignItems="center">
          <Grid item xs zeroMinWidth>
            <Typography noWrap>
              <strong>RCS 브랜드 선택</strong>
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <CommonButton
              variant="contained"
              color="primary"
              fullWidth
              newTabIcon
              href="/rcs/brands"
              target="_blank"
            >
              새 브랜드 연동
            </CommonButton>
          </Grid>
        </Grid>
      </Grid>
      {brandList?.length < 1 && (
        <Grid item xs={12}>
          <Box p={2}>
            <Typography variant="body2" color="textSecondary" align="center">
              연동된 RCS 브랜드가 없습니다.
            </Typography>
          </Box>
        </Grid>
      )}
      {brandList.map(rcsBrand => {
        return (
          <Grid item xs={12} sm={6}>
            <RcsBrandItem rcsBrand={rcsBrand} onSelect={onSelect} />
          </Grid>
        )
      })}
    </Grid>
  )
}
const newTheme = createTheme(
  merge({}, nurigoTheme, {
    palette: {
      primary: {
        main: config.purplebookTab.rcs.mainColor,
        dark: config.purplebookTab.rcs.darkColor
      }
    }
  })
)
const RcsBrandSelectForm = ({ classes: cls, proxy, ...props }) => {
  const { brandList = [], onSelect } = props
  return (
    <MuiThemeProvider theme={newTheme}>
      <div className={cls.root}>
        <RcsBrandItems brandList={brandList} onSelect={onSelect} />
      </div>
    </MuiThemeProvider>
  )
}

RcsBrandSelectForm.defaultProps = setDefaultProps(useProps)
RcsBrandSelectForm.propTypes = setPropTypes(useProps)
const commonStyles = theme => ({
  root: {}
})
export default React.memo(
  withStyles(commonStyles)(
    withCompWidth(RcsBrandSelectForm, { disabled: true })
  )
  // ,(prevProps, nextProps) => {
  //   return isEqualProps(nextProps, prevProps)
  // }
)
